import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { UseFormRegisterReturn } from "react-hook-form";

function useSecretInput() {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return { showPassword, toggleShowPassword };
}

interface SecretInputProps extends Omit<TextFieldProps, "slotProps" | "type"> {
  register?: Omit<UseFormRegisterReturn, "ref">;
}

export default function SecretInput({ register, ...props }: SecretInputProps) {
  const { showPassword, toggleShowPassword } = useSecretInput();

  return (
    <TextField
      {...props}
      {...register}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <ToggleShowPassword
            showPassword={showPassword}
            toggleShowPassword={toggleShowPassword}
          />
        ),
      }}
    />
  );
}

interface ToggleShowPasswordProps {
  showPassword: boolean;
  toggleShowPassword: () => void;
}

export function ToggleShowPassword({
  showPassword,
  toggleShowPassword,
}: ToggleShowPasswordProps) {
  return (
    <InputAdornment position="end">
      <IconButton
        onClick={toggleShowPassword}
        onMouseDown={(event) => event.preventDefault()}
        aria-label={showPassword ? "Hide password" : "Show password"}
        edge="end"
      >
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );
}
